import Header from "../header/Header";
import Image from "next/image";
import Solution, { FullSolution } from "../../../models/Solution";
import ThumbsupSvg from "../icons/ThumbsupSvg";
import CommentBubbleSvg from "../icons/CommentBubbleSvg";
import Avatar from "../user/Avatar";
import Img from "../images/Img";
import Link from "next/link";
import Divider from "../divider/Divider";
import Markdown from "../../_general/Markdown";
import UserInfo from "../user/UserInfo";
import UserPublishDate from "../user/UserWithPublishDate";

export interface SolutionCardProps {
  solution: FullSolution;
}

const SolutionCard: React.FC<SolutionCardProps> = (props) => {
  const { solution } = props;
  let mainUser = solution.users.slice(0, 1)[0];
  return (
    <Link href={`/soluciones/${solution.slug}`}>
      <a>
        <div className="shadow-xl bg-white dark:shadow-none dark:bg-theme-dark-light w-full sm:w-full rounded-xl px-4 py-6 space-y-4">
          <Header as="h4" className="mb-4 font-semibold">{solution.project.title}</Header>
          <div className="">
            <Img
              image={solution.project.bannerImage}
              cloudinaryTransformation={{}}
              width={540}
              height={292}
              className="object-cover aspect-w-16 aspect-h-9"
            />
          </div>
          <div className="flex justify-between items-center">
            <UserPublishDate user={mainUser} publishDate={solution.completed_at} />
          </div>
          <Divider />
          <div className="flex flex-row justify-between items-center space-x-4">
            <div className="text-solid-blue dark:text-highlight-yellow">
              {/* JavaScript */}
            </div>
            <div className="flex flex-row items-center space-x-4">
              <div className="flex flex-row items-center justify-center text-lg">
                <CommentBubbleSvg className="text-input-border fill-current w-6 h-6 mr-2" /> {solution.commentCount || 0}
              </div>
              {/* <div className="flex flex-row items-center justify-center text-lg">
                <ThumbsupSvg className="h-6 w-6 text-primary stroke-current mr-2" /> {solution.upvotes || 0}
              </div> */}
            </div>
          </div>
          <Divider />
          {/* <p className="markdown">
            <Markdown content={solution.feedbackRequest} />
          </p> */}
        </div>
      </a>
    </Link>
  );
};

export default SolutionCard;
